<template>
  <header class="humo-header">
    <h1 v-if="props.title" class="header-title">{{ props.title }}</h1>
    <div class="visual-wrapper">
      <!-- Desktop visuals -->
      <video
          autoplay
          loop
          muted
          playsinline
          :src="`${baseUrl}/video/day-header-small.webm`"
          id="loopVideo"
          v-if="isDay && isMobile"
          class="visual mobile-visual day-visual"
          :class="{ 'is-active': isDay }"
      ></video>
      <video
          autoplay
          loop
          muted
          playsinline
          :src="`${baseUrl}/video/day-header.webm`"
          id="loopVideo"
          v-if="isDay && !isMobile"
          class="visual desktop-visual day-visual"
          :class="{ 'is-active': isDay }"
      ></video>

      <video
          autoplay
          loop
          muted
          playsinline
          :src="`${baseUrl}/video/night-header-small.webm`"
          id="loopVideo"
          v-if="!isDay && isMobile"
          class="visual mobile-visual night-visual"
          :class="{ 'is-active': !isDay }"
      ></video>
      <video
          autoplay
          loop
          muted
          playsinline
          :src="`${baseUrl}/video/night-header.webm`"
          id="loopVideo"
          v-if="!isDay && !isMobile"
          class="visual desktop-visual night-visual"
          :class="{ 'is-active': !isDay }"
      ></video>
    </div>
    <p v-if="props.lead" class="lead" v-html="props.lead"></p>
  </header>
</template>

<script setup>
import { onMounted, ref } from 'vue'

let isMobile = ref(false)

const props = defineProps({ title: String, lead: String });

let isDay = ref(true)
const baseUrl = process.env.NODE_ENV === 'production' ? window.location.origin + '/tool' : window.location.origin

// Get the current time
const now = new Date()
const currentHour = now.getHours()

// If it's between 6 and 18, show the day header
isDay.value = currentHour >= 6 && currentHour < 18

// set mobile value
isMobile.value = window.innerWidth <= 768

// Check for route params to override the time to preview the night header
const urlParams = new URLSearchParams(window.location.search)
const night = urlParams.get('night')
if (night) {
  isDay.value = !night
}

onMounted(() => {
  window.addEventListener('resize', () => {
    isMobile.value = window.innerWidth <= 768
  })
})
</script>
